import { AbstractSymbol } from "../../../../abstracts/elements/AbstractSymbol";
import { log } from "../../../../abstracts/utils/AbstractConsole";
import { symbolsArray } from "../../../config/DDDConfig";
import { DDDSymbolNames } from "../../../types/DDDEnums";
// import { DDDMysterySymbol } from "./DDDMysterySymbol";
import { DDDScatterSymbol } from "./DDDScatterSymbol";
import { DDDSymbol } from "./DDDSymbol";
import { DDDWildSymbol } from "./DDDWildSymbol";
import { DDDXGodSymbol } from "./DDDXGodSymbol";
import { DDDXNudgeSymbol } from "./DDDXNudgeSymbol";

export class DDDSymbolPool {
    private symbolName: string;
    private pool: AbstractSymbol[] = [];

    constructor(symbolName: string) {
        this.symbolName = symbolName;
    }

    public getSymbol(): AbstractSymbol {
        let symbol: AbstractSymbol | undefined = this.pool.shift();

        if (symbol === undefined) {
            switch (this.symbolName) {
                case DDDSymbolNames.XN_1:
                case DDDSymbolNames.XN_2:
                case DDDSymbolNames.XN_3:
                    symbol = new DDDXNudgeSymbol(this.symbolName);
                    break;

                case DDDSymbolNames.XGOD_1:
                case DDDSymbolNames.XGOD_2:
                case DDDSymbolNames.XGOD_3:
                    symbol = new DDDXGodSymbol(this.symbolName);
                    break;

                case DDDSymbolNames.WILD:
                    symbol = new DDDWildSymbol();
                    break;

                case DDDSymbolNames.SCATTER:
                    symbol = new DDDScatterSymbol();
                    break;

                default:
                    symbol = new DDDSymbol(this.symbolName);
            }
        }

        return symbol;
    }

    public returnSymbol(symbol: AbstractSymbol) {
        symbol.reset();
        symbol.parent?.removeChild(symbol);

        this.pool.push(symbol);
    }
}

const poolsMap: { [k: string]: any } = {};

[...symbolsArray].forEach((symbolName: string) => {
    poolsMap[symbolName] = new DDDSymbolPool(symbolName);
});

export const getSymbolFromPool = (name: string): AbstractSymbol => {
    if (!poolsMap[name]) {
        log(`Texture for symbol ${name} does not exist!`);
    }

    return poolsMap[name].getSymbol()!;
};
export const returnSymbolToPool = (symbol: AbstractSymbol) =>
    poolsMap[symbol.name].returnSymbol(symbol);
